
















































import {
  Vue,
  Component,
  Prop,
} from 'vue-property-decorator';
import { VbPagination } from '@/shared/pagination/pagination.component.vue';
import Access from '@/domain/access/domain/access.entity';
import Pagination from '@/domain/pagination.entity';
import ModalWarning from '@/shared/modal/modal-warning.component.vue';
import header from './header.json';
import ProfileSelect from './profile-select.component.vue';

@Component({
  components: { VbPagination, ModalWarning, ProfileSelect },
})
export default class AccessionConfigurationList extends Vue {
  @Prop({
    type: Array,
    required: true,
  }) accesses!: Access[];

  @Prop({
    type: Pagination,
    required: true,
  })
  pagination!: Pagination;

  @Prop({
    type: Boolean,
    default: false,
  })
  loading!: boolean

  header: any = header;

  showConfirmationDialog: boolean = false;

  accessIdToDelete: string = '';

  accessUsernameToDelete: string = '';

  changePage(pagination: Pagination): void {
    this.$emit('updateTable', pagination);
  }

  updateSortBy(sortBy: string[]): void {
    this.$emit('updateSortBy', sortBy);
  }

  updateSortDesc(sortDesc: string[]): void {
    this.$emit('updateSortDesc', sortDesc);
  }

  updateOptions(options: any): void {
    this.changePage(new Pagination({
      ...this.pagination,
      sortBy: options.sortBy,
      sortDesc: options.sortDesc,
    }));
  }

  openConfirmationDialog(access: any): void {
    this.accessIdToDelete = access.id;
    this.accessUsernameToDelete = access.username;
    this.showConfirmationDialog = true;
  }

  closeConfirmationDialog(): void {
    this.showConfirmationDialog = false;
  }

  deleteAccess(): void {
    this.$emit('delete', this.accessIdToDelete);
    this.closeConfirmationDialog();
  }

  updateProfile(id: string, profile: string) {
    this.$emit('updateProfile', { id, profile });
  }

  get confirmMessage(): string {
    return `Deseja mesmo remover acesso do e-mail <b>${this.accessUsernameToDelete}@db1.com.br</b>?`;
  }
}
